// extracted by mini-css-extract-plugin
module.exports = {"filename-text":"LoaderDragDropFile_filename-text__fpKYc","container":"LoaderDragDropFile_container__YD1ZO","wrapper-image":"LoaderDragDropFile_wrapper-image__kc9JJ"};